export class NutritionDto {
  public protein: string;
  public carbohydrate: string;
  public sugars: string;
  public fat: string;
  public saturates: string;
  public fibre: string;
  public sodium: string;
}
